// import { Vue } from 'vue/types/vue';
export function test() { }
export function getComponentCount() {
    const count = 1;
    // while (node.$children && node.$children.length > 0) {
    // }
    return count;
}
